/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */

import {
  DialogType
} from '@ion/features/src/dialogs/types';
import {
  useDialog,
  UseDialogResult
} from '@ion/features/src/dialogs/useDialog';

/**
 * Hook for managing the showing & hiding of a bulk action dialog.
 */
export const useBulkActionDialog = (): UseDialogResult => {
  const {
    show,
    open,
    close,
    clearForm,
    selectedGridData
  } = useDialog(DialogType.BULK_ACTION_DIALOG);

  return {
    show,
    open,
    close,
    clearForm,
    selectedGridData
  };
};

export default useBulkActionDialog;
